import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ReactApexChart from "react-apexcharts";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { all_routes } from "../../../Router/all_routes";
import CollapesIcon from "../../../core/common/tooltip-content/collapes";
import CommonFooter from "../../../core/common/footer/commonFooter";
import { API_BASE_URL } from "../Config/Config";
import axios from "axios";
import { Table, Spin } from "antd";

const SuperAdminDashboard = () => {
  const routes = all_routes;
  const [punchesData, setPunchesData] = useState([]);
  const [monthlySubs, setMonthlySubs] = useState([]);
  const [planData, setPlanData] = useState([]);
  const [allCounts, setAllCounts] = useState([]);
  console.log(allCounts, "allcounts");
  const [recentTransactions, setRecentTransactions] = useState([]);
  const [recentPunches, setRecentPunches] = useState([]);
  const [recentPlanExpired, setRecentPlanExpired] = useState([]);
  const [loading, setLoading] = useState(false);

  const [ApexChart] = React.useState({
    series: [
      {
        name: "Messages",
        data: [5, 10, 7, 5, 10, 7, 5],
      },
    ],

    chart: {
      type: "bar",
      width: 70,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      dropShadow: {
        enabled: false,
        top: 3,
        left: 14,
        blur: 4,
        opacity: 0.12,
        color: "#fff",
      },
      sparkline: {
        enabled: !0,
      },
    },
    markers: {
      size: 0,
      colors: ["#F26522"],
      strokeColors: "#fff",
      strokeWidth: 2,
      hover: {
        size: 7,
      },
    },
    plotOptions: {
      bar: {
        horizontal: !1,
        columnWidth: "35%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: !0,
      width: 2.5,
      curve: "smooth",
    },
    colors: ["#FF6F28"],
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
      ],
      labels: {
        show: false,
      },
    },
    tooltip: {
      show: false,
      theme: "dark",
      fixed: {
        enabled: false,
      },
      x: {
        show: false,
      },

      marker: {
        show: false,
      },
    },
  });
  const [ApexChart2] = React.useState({
    series: [
      {
        name: "Messages",
        data: [5, 3, 7, 6, 3, 10, 5],
      },
    ],

    chart: {
      type: "bar",
      width: 70,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      dropShadow: {
        enabled: false,
        top: 3,
        left: 14,
        blur: 4,
        opacity: 0.12,
        color: "#fff",
      },
      sparkline: {
        enabled: !0,
      },
    },
    markers: {
      size: 0,
      colors: ["#F26522"],
      strokeColors: "#fff",
      strokeWidth: 2,
      hover: {
        size: 7,
      },
    },
    plotOptions: {
      bar: {
        horizontal: !1,
        columnWidth: "35%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: !0,
      width: 2.5,
      curve: "smooth",
    },
    colors: ["#4B3088"],
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
      ],
      labels: {
        show: false,
      },
    },
    tooltip: {
      show: false,
      theme: "dark",
      fixed: {
        enabled: false,
      },
      x: {
        show: false,
      },

      marker: {
        show: false,
      },
    },
  });
  const [ApexChart3] = React.useState({
    series: [
      {
        name: "Messages",
        data: [8, 10, 10, 8, 8, 10, 8],
      },
    ],

    chart: {
      type: "bar",
      width: 70,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      dropShadow: {
        enabled: false,
        top: 3,
        left: 14,
        blur: 4,
        opacity: 0.12,
        color: "#fff",
      },
      sparkline: {
        enabled: !0,
      },
    },
    markers: {
      size: 0,
      colors: ["#F26522"],
      strokeColors: "#fff",
      strokeWidth: 2,
      hover: {
        size: 7,
      },
    },
    plotOptions: {
      bar: {
        horizontal: !1,
        columnWidth: "35%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: !0,
      width: 2.5,
      curve: "smooth",
    },
    colors: ["#177DBC"],
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
      ],
      labels: {
        show: false,
      },
    },
    tooltip: {
      show: false,
      theme: "dark",
      fixed: {
        enabled: false,
      },
      x: {
        show: false,
      },

      marker: {
        show: false,
      },
    },
  });
  const [ApexChart4] = React.useState({
    series: [
      {
        name: "Messages",
        data: [5, 10, 7, 5, 10, 7, 5],
      },
    ],

    chart: {
      type: "bar",
      width: 70,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      dropShadow: {
        enabled: false,
        top: 3,
        left: 14,
        blur: 4,
        opacity: 0.12,
        color: "#fff",
      },
      sparkline: {
        enabled: !0,
      },
    },
    markers: {
      size: 0,
      colors: ["#F26522"],
      strokeColors: "#fff",
      strokeWidth: 2,
      hover: {
        size: 7,
      },
    },
    plotOptions: {
      bar: {
        horizontal: !1,
        columnWidth: "35%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: !0,
      width: 2.5,
      curve: "smooth",
    },
    colors: ["#2DCB73"],
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
      ],
      labels: {
        show: false,
      },
    },
    tooltip: {
      show: false,
      theme: "dark",
      fixed: {
        enabled: false,
      },
      x: {
        show: false,
      },

      marker: {
        show: false,
      },
    },
  });
  useEffect(() => {
    setLoading(true);
    const fetchDashboard = async () => {
      try {
        const [
          punchRes,
          monthRes,
          planRes,
          allCountsRes,
          recentTransactionsRes,
          recentPunchesRes,
          recentPlanExpiredRes,
        ] = await Promise.all([
          axios.get(`${API_BASE_URL}/api/dashboard/getdashboardpunches`),
          axios.get(`${API_BASE_URL}/api/getdashboardmonthly`),
          axios.get(`${API_BASE_URL}/api/getdashboardplancount`),
          axios.get(`${API_BASE_URL}/api/getdashboardallcounts`),
          axios.get(`${API_BASE_URL}/api/getrecenttransactions`),
          axios.get(`${API_BASE_URL}/api/getrecentpunches`),
          axios.get(`${API_BASE_URL}/api/getrecentplanexpired`),
        ]);

        if (punchRes.data.status) setPunchesData(punchRes.data.ResultData);
        if (monthRes.data.Status) setMonthlySubs(monthRes.data.ResultData);
        if (planRes.data.Status) setPlanData(planRes.data.ResultData);
        if (allCountsRes.data.Status)
          setAllCounts(allCountsRes.data.ResultData);
        if (recentTransactionsRes.data.Status)
          setRecentTransactions(recentTransactionsRes.data.ResultData);
        if (recentPunchesRes.data.Status)
          setRecentPunches(recentPunchesRes.data.ResultData);
        if (recentPlanExpiredRes.data.Status)
          setRecentPlanExpired(recentPlanExpiredRes.data.ResultData);
      } catch (err) {
        console.error("Dashboard API error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboard();
  }, []);

  const dayOrder = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  const orderedPunches = dayOrder.map(
    (day) => punchesData.find((p) => p.DayName === day)?.PunchCount || 0,
  );

  console.log(orderedPunches,"orederrrrrrrrrrrrrrr");
  const CompanyChart = {
    chart: { height: 240, type: "bar", toolbar: { show: false } },
    colors: ["#212529"],
    plotOptions: {
      bar: {
        borderRadius: 10,
        horizontal: false,
        endingShape: "rounded",
      },
    },
    series: [{ name: "Punches", data: orderedPunches }],
    xaxis: {
      categories: ["M", "T", "W", "T", "F", "S", "S"],
      labels: { style: { colors: "#6B7280", fontSize: "13px" } },
    },
    yaxis: { labels: { show: false } },
    grid: { borderColor: "#E5E7EB", strokeDashArray: 5 },
    legend: { show: false },
    dataLabels: { enabled: false },
    fill: { opacity: 1 },
  };

  // ---- Monthly Subscriptions ------------------------------------------------
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const subscriptionValues = monthNames.map((_, idx) => {
    const item = monthlySubs.find(
      (m) =>
        m.MonthName ===
        [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ][idx],
    );
    return item ? item.SubscriptionCount : 0;
  });

  const RevenueChart = {
    chart: { height: 230, type: "bar", toolbar: { show: false } },
    colors: ["#FF6F28"],
    plotOptions: {
      bar: { borderRadius: 5, horizontal: false, endingShape: "rounded" },
    },
    series: [{ name: "Subscriptions", data: subscriptionValues }],
    xaxis: {
      categories: monthNames,
      labels: { style: { colors: "#6B7280", fontSize: "13px" } },
    },
    yaxis: { min: 0, max: Math.max(...subscriptionValues, 0) + 50 },
    grid: { borderColor: "transparent", strokeDashArray: 5 },
    legend: { show: false },
    dataLabels: { enabled: false },
    tooltip: { y: { formatter: (val) => `${val} Subscriptions` } },
    fill: { opacity: 1 },
  };

  const getPunchById = (ServiceTypeId) => {
    const found = planData?.find((p) => p?.ServiceTypeId === ServiceTypeId);
    return found ? found?.TodayPunches : 0;
  };

  const liteCount = getPunchById(1); // RollCall-Lite
  const standardCount = getPunchById(2); // RollCall-Standard
  const premiumCount = getPunchById(7); // RollCall-Premium

  const PlanChart = {
    chart: { height: 240, type: "donut", toolbar: { show: false } },
    colors: ["#FFC107", "#1B84FF", "#F26522"],
    series: [liteCount, standardCount, premiumCount],
    labels: ["Lite", "Standard", "Premium"],
    plotOptions: {
      pie: { donut: { size: "50%", labels: { show: false } } },
    },
    stroke: { show: true, width: 0, colors: "#fff" },
    dataLabels: { enabled: false },
    legend: { show: false },
    responsive: [
      {
        breakpoint: 480,
        options: { chart: { height: 180 }, legend: { position: "bottom" } },
      },
    ],
  };

  const columns = [
    {
      title: "Company",
      dataIndex: "ClientName",
      key: "ClientName",
      render: (_, record) => (
        <div className="d-flex align-items-center">
          <div className=" flex-fill">
            <h6 className="fs-medium text-truncate">
              <Link to="#">{record.ClientName}</Link>
            </h6>
            <p className="fs-13 d-inline-flex align-items-center">
              <span className="text-info">#{record.OrderNumber}</span>
              <i className="ti ti-circle-filled fs-6 text-primary mx-1" />
              {record.OrderDateTime}
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      align: "right",
      render: (_, record) => (
        <div className="text-sm-end">
          <h6 className="mb-1">₹{record.Amount}</h6>
          {/* <p className="fs-13">Standard</p> */}
        </div>
      ),
    },
  ];
  const columns1 = [
    {
      title: "ClientNameShort",
      dataIndex: "ClientNameShort",
      key: "ClientNameShort",
      render: (_, record) => (
        <div className="d-flex align-items-center">
          <div className=" flex-fill">
            <h6 className="fs-medium text-truncate">
              <Link to="#">{record.ClientNameShort}</Link>
            </h6>
            <p className="fs-13 d-inline-flex align-items-center">
              <span className="text-info">#{record.SuperId}</span>
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "PunchesReceived",
      dataIndex: "PunchesReceived",
      key: "PunchesReceived",
      align: "right",
      render: (_, record) => (
        <div className="text-sm-end">
          <h6 className="mb-1">{record.PunchesReceived} Punches</h6>
          {/* <p className="fs-13">Standard</p> */}
        </div>
      ),
    },
  ];
  const columns2 = [
    {
      title: "OrgName",
      dataIndex: "OrgName",
      key: "OrgName",
      render: (_, record) => (
        <div className="d-flex align-items-center">
          <div className=" flex-fill">
            <h6 className="fs-medium text-truncate" title={record.OrgName}>
              <Link to="#">
                {record.OrgName?.length > 15
                  ? record.OrgName.substring(0, 15) + "..."
                  : record.OrgName}
              </Link>
            </h6>
            <p className="fs-13 d-inline-flex align-items-center">
              <span className="text-info">#{record.PlanName}</span>
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "PunchesReceived",
      dataIndex: "PunchesReceived",
      key: "PunchesReceived",
      align: "right",
      render: (_, record) => (
        <div className="text-sm-end">
          <h6 className="mb-1">{record.ExpiredDate}</h6>
          <Link to="#" className="fs-13 text-info">
            Reminder
          </Link>
        </div>
      ),
    },
  ];
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-lg-flex align-items-center justify-content-between mb-4">
          <div>
            <h2 className="mb-1">Welcome, Admin</h2>
            <p>
              You have <span className="text-primary fw-bold">200+</span>{" "}
              Orders, Today
            </p>
          </div>
          <ul className="table-top-head">
            <li></li>
            <CollapesIcon />
          </ul>
        </div>
        {/* Welcome Wrap */}
        <div className="welcome-wrap mb-4">
          <div className=" d-flex align-items-center justify-content-between flex-wrap">
            <div className="mb-3">
              <h2 className="mb-1 text-white">Welcome Back, Admin</h2>
              <p className="text-light">14 New Clients Subscribed Today !!!</p>
            </div>
            <div className="d-flex align-items-center flex-wrap mb-1">
              <Link
                to={routes.companies}
                className="btn btn-dark btn-md me-2 mb-2"
              >
                Clients
              </Link>
              <Link to={routes.devices} className="btn btn-light btn-md mb-2">
                Devices
              </Link>
            </div>
          </div>
          <div className="welcome-bg">
            <ImageWithBasePath
              src="assets/img/bg/welcome-bg-02.svg"
              alt="img"
              className="welcome-bg-01"
            />
            {/* <ImageWithBasePath
              src="assets/img/bg/welcome-bg-03.svg"
              alt="img"
              className="welcome-bg-02"
            /> */}
            <ImageWithBasePath
              src="assets/img/bg/welcome-bg-01.svg"
              alt="img"
              className="welcome-bg-03"
            />
          </div>
        </div>
        {/* /Welcome Wrap */}
        <div className="row">
          {/* Total Companies */}
          <div className="col-xl-3 col-sm-6 d-flex">
            <div className="card flex-fill">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <span className="avatar avatar-md bg-dark mb-3">
                    <i className="ti ti-building fs-16" />
                  </span>
                  {/* <span className="badge bg-success fw-normal mb-3">+19.01%</span> */}
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                  <h2 className="mb-1">{allCounts[0]?.TotalClients}</h2>
                    <p className="fs-13">Total Clients</p>
                  </div>
                  <ReactApexChart
                    options={ApexChart}
                    series={ApexChart.series}
                    type="bar"
                    width={70}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* /Total Companies */}
          {/* Active Companies */}
          <div className="col-xl-3 col-sm-6 d-flex">
            <div className="card flex-fill">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <span className="avatar avatar-md bg-dark mb-3">
                    <i className="ti ti-carousel-vertical fs-16" />
                  </span>
                  {/* <span className="badge bg-danger fw-normal mb-3">-12%</span> */}
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                  <h2 className="mb-1">{allCounts[0]?.TotalDevicesActive}</h2>
                    <p className="fs-13">Active Devices</p>
                  </div>
                  <ReactApexChart
                    options={ApexChart2}
                    series={ApexChart2.series}
                    type="bar"
                    width={70}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* /Active Companies */}
          {/* Total Subscribers */}
          <div className="col-xl-3 col-sm-6 d-flex">
            <div className="card flex-fill">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <span className="avatar avatar-md bg-dark mb-3">
                    <i className="ti ti-shopping-cart fs-16" />
                  </span>
                  {/* <span className="badge bg-success fw-normal mb-3">+6%</span> */}
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h2 className="mb-1">{allCounts[2]?.Value}</h2>
                    <p className="fs-13">Total Orders</p>
                  </div>
                  <ReactApexChart
                    options={ApexChart3}
                    series={ApexChart3.series}
                    type="bar"
                    width={70}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* /Total Subscribers */}
          {/* Total Earnings */}
          <div className="col-xl-3 col-sm-6 d-flex">
            <div className="card flex-fill">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <span className="avatar avatar-md bg-dark mb-3">
                    <i className="ti ti-businessplan fs-16" />
                  </span>
                  {/* <span className="badge bg-danger fw-normal mb-3">-16%</span> */}
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h2 className="mb-1">{allCounts[3]?.Value}</h2>
                    <p className="fs-13">Total Orders Amount</p>
                  </div>
                  <ReactApexChart
                    options={ApexChart4}
                    series={ApexChart4.series}
                    type="bar"
                    width={70}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* /Total Earnings */}
        </div>
        <div className="row">
          {/* Companies */}
          <div className="col-xxl-3 col-xl-3 d-flex">
            <div className="card flex-fill">
              <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                <h5 className="mb-2">Weekly Punches </h5>
                <div className="dropdown mb-2">
                  <Link
                    to="#"
                    className="btn btn-white border btn-sm d-inline-flex align-items-center"
                    // data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-calendar me-1" />
                    Last 7 Days
                  </Link>
                </div>
              </div>
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between flex-wrap">
                  <div className="mb-1"></div>
                  <p className="fs-13 text-gray-9 d-flex align-items-center mb-1">
                    <i className="ti ti-circle-filled me-1 fs-6 text-back" />
                    Punches
                  </p>
                </div>
                <Spin spinning={loading}>
                  <ReactApexChart
                    id="company-chart"
                    options={CompanyChart}
                    series={CompanyChart.series}
                    type="bar"
                    height={240}
                  />
                </Spin>
              </div>
            </div>
          </div>
          {/* /Companies */}
          {/* Revenue */}
          <div className="col-xxl-6 col-xl-6 d-flex">
            <div className="card flex-fill">
              <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                <h5 className="mb-2">Subscriptions</h5>
                <div className="dropdown mb-2">
                  <Link
                    to="#"
                    className="btn btn-white border btn-sm d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-calendar me-1" />
                    2025
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        2024
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        2025
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        2023
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="card-body pb-0">
                <div className="d-flex align-items-center justify-content-between flex-wrap">
                  <div className="mb-1"></div>
                  <p className="fs-13 text-gray-9 d-flex align-items-center mb-1">
                    <i className="ti ti-circle-filled me-1 fs-6 text-primary" />
                    Subscriptions
                  </p>
                </div>
                <Spin spinning={loading}>
                  <ReactApexChart
                    id="revenue-income"
                    options={RevenueChart}
                    series={RevenueChart.series}
                    type="bar"
                    height={230}
                  />
                </Spin>
              </div>
            </div>
          </div>
          {/* /Revenue */}
          {/* Top Plans */}
          <div className="col-xxl-3 col-xl-3 d-flex">
            <div className="card flex-fill">
              <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                <h5 className="mb-2">Today Punches</h5>
              </div>
              <div className="card-body">
                <Spin spinning={loading}>
                  <ReactApexChart
                    options={PlanChart}
                    series={PlanChart.series}
                    type="donut"
                    height={240}
                  />
                </Spin>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <p className="f-13 mb-0">
                    <i className="ti ti-circle-filled text-primary me-1" />
                    Premium
                  </p>
                  <p className="f-13 fw-medium text-gray-9">{premiumCount}</p>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <p className="f-13 mb-0">
                    <i className="ti ti-circle-filled text-warning me-1" />
                    Standard
                  </p>
                  <p className="f-13 fw-medium text-gray-9">{standardCount}</p>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-0">
                  <p className="f-13 mb-0">
                    <i className="ti ti-circle-filled text-info me-1" />
                    Lite{" "}
                  </p>
                  <p className="f-13 fw-medium text-gray-9">{liteCount}</p>
                </div>
              </div>
            </div>
          </div>
          {/* /Top Plans */}
        </div>
        <div className="row">
          {/* Recent Transactions */}
          <div className="col-xxl-4 col-xl-4 d-flex">
            <div className="card flex-fill">
              <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                <h5 className="mb-2">Recent Transactions</h5>
                <Link className="btn btn-light btn-md mb-2">View All</Link>
              </div>

              <div className="card-body pb-2 pt-0">
                <Spin spinning={loading}>
                  <Table
                    columns={columns}
                    dataSource={recentTransactions}
                    pagination={false}
                    showHeader={false} // UI look same as before
                    rowClassName={() => "mb-3"} // keep spacing between rows
                  />
                </Spin>
              </div>
            </div>
          </div>
          {/* /Recent Transactions */}
          {/* Recently Registered */}
          <div className="col-xxl-4 col-xl-4 d-flex">
            <div className="card flex-fill">
              <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                <h5 className="mb-2">Recent Punches</h5>
                <Link
                  to={routes.superAdminPurchaseTransaction}
                  className="btn btn-light btn-md mb-2"
                >
                  View All
                </Link>
              </div>
              <div className="card-body pb-2 pt-0">
                <Spin spinning={loading}>
                  <Table
                    columns={columns1}
                    dataSource={recentPunches}
                    pagination={false}
                    showHeader={false} // UI look same as before
                    rowClassName={() => "mb-3"} // keep spacing between rows
                  />
                </Spin>
              </div>
            </div>
          </div>
          {/* /Recent Registered */}
          {/* Recent Plan Expired */}
          <div className="col-xxl-4 col-xl-4 d-flex">
            <div className="card flex-fill">
              <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                <h5 className="mb-2">Renewals</h5>
                <Link className="btn btn-light btn-md mb-2">View All</Link>
              </div>
              <div className="card-body pb-2 pt-0">
                <Spin spinning={loading}>
                  <Table
                    columns={columns2}
                    dataSource={recentPlanExpired}
                    pagination={false}
                    showHeader={false} // UI look same as before
                    rowClassName={() => "mb-3"} // keep spacing between rows
                  />
                </Spin>
              </div>
            </div>
          </div>
          {/* /Recent Plan Expired */}
        </div>
      </div>
      <CommonFooter />
    </div>
  );
};

export default SuperAdminDashboard;
